import * as React from "react";

const PlusCircleFaq: React.FC = () => {
    return (
        <svg
            focusable="false"
            xmlns="http://www.w3.org/2000/svg"
            width="56"
            height="56"
            viewBox="0 0 56 56"
            fill="none"
        >
            <circle cx="28" cy="28" r="20" fill="#000000" />
            <line x1="28" y1="23" x2="28" y2="33" stroke="#ffffff" strokeWidth="5" strokeLinecap="round" />
            <line x1="23" y1="28" x2="33" y2="28" stroke="#ffffff" strokeWidth="5" strokeLinecap="round" />
        </svg>
    );
};

export default React.memo(PlusCircleFaq);
